<template>
<div class="Section__wrapper">
  <div class="Section__title" data-locator="section-title">
    <h2 class="heading-sm-bold">
      <slot name="title"></slot>
    </h2>
  </div>
  <div class="Section__content text-text-secondary"  data-locator="section-content">
    <slot name="content"></slot>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SigningChecklistSection',
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.Section__wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.Section__title {
  align-items: flex-start;
  color: rgb(var(--v-theme-text-primary));
  @include border-radius('border-radius-3');
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px 12px;
}
</style>
